export class AssetReportModel {
    constructor() {
        this.startDateAsString = "";
        this.endDateAsString = "";
    }
}
export default class AssetReport extends AssetReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
